module.exports = __webpack_public_path__ + "static/media/Galleria - Sand_White.0f561bc5.jpg";